<template>
  <div
    class="settings-instruction"
    v-if="formData"
  >
    <h2 class="headline">Status checker</h2>
    <v-form v-if="isLoader" class="form">

      <!--THANK YOU YOUR PASSSWORD WAS RESET-->
      <v-card>
        <content-editor
          label="Text for Thank You your password was reset"
          class="pos-relative"
          v-model="formData.metadata.textYourPasswordWasReset.content"
          @input="$v.formData.metadata.textYourPasswordWasReset.content.$touch"
          @blur="$v.formData.metadata.textYourPasswordWasReset.content.$touch"
          :error="$v.formData.metadata.textYourPasswordWasReset.content"
        />
      </v-card>
      <!--THANK YOU YOUR PASSSWORD WAS RESET-->

      <!--SUCCESS SEND EMAIL-->
      <v-card>
        <content-editor
          label="Text for success send email"
          class="pos-relative"
          v-model="formData.metadata.textSuccessSendEmail.content"
          @input="$v.formData.metadata.textSuccessSendEmail.content.$touch"
          @blur="$v.formData.metadata.textSuccessSendEmail.content.$touch"
          :error="$v.formData.metadata.textSuccessSendEmail.content"
        />
      </v-card>
      <!--SUCCESS SEND EMAIL-->

      <!--LOG IN-->
      <v-card>
        <content-editor
          label="Text for log in user "
          class="pos-relative"
          v-model="formData.metadata.textLogIn.content"
          @input="$v.formData.metadata.textLogIn.content.$touch"
          @blur="$v.formData.metadata.textLogIn.content.$touch"
          :error="$v.formData.metadata.textLogIn.content"
        />
      </v-card>
      <!--LOG IN-->

      <!-- USER LOGGED GREETING -->
      <v-card>
        <content-editor
          label="Text for logged user Greeting "
          class="pos-relative"
          v-model="formData.metadata.textLoggedUserForGreeting.content"
          @input="$v.formData.metadata.textLoggedUserForGreeting.content.$touch"
          @blur="$v.formData.metadata.textLoggedUserForGreeting.content.$touch"
          :error="$v.formData.metadata.textLoggedUserForGreeting.content"
        />
      </v-card>
      <!-- USER LOGGED GREETING -->

      <!-- USER LOGGED STATUS -->
      <v-card>
        <content-editor
          label="Text for logged user status"
          class="pos-relative"
          v-model="formData.metadata.textLoggedUserForStatusUser.content"
          @input="$v.formData.metadata.textLoggedUserForStatusUser.content.$touch"
          @blur="$v.formData.metadata.textLoggedUserForStatusUser.content.$touch"
          :error="$v.formData.metadata.textLoggedUserForStatusUser.content"
        />
      </v-card>
      <!-- USER LOGGED STATUS -->

      <!-- USER LOGGED COUNTER -->
      <v-card>
        <content-editor
          label="Text for logged user counter"
          class="pos-relative"
          v-model="formData.metadata.textLoggedUserForCounterMessage.content"
          @input="$v.formData.metadata.textLoggedUserForCounterMessage.content.$touch"
          @blur="$v.formData.metadata.textLoggedUserForCounterMessage.content.$touch"
          :error="$v.formData.metadata.textLoggedUserForCounterMessage.content"
        />
      </v-card>
      <!-- USER LOGGED COUNTER -->

      <!-- USER LOGGED CONTACT US -->
      <v-card>
        <content-editor
          label="Text for logged user contact us"
          class="pos-relative"
          v-model="formData.metadata.textLoggedUserForContactUs.content"
          @input="$v.formData.metadata.textLoggedUserForContactUs.content.$touch"
          @blur="$v.formData.metadata.textLoggedUserForContactUs.content.$touch"
          :error="$v.formData.metadata.textLoggedUserForContactUs.content"
        />
      </v-card>
      <!-- USER LOGGED CONTACT US -->

      <!--SEND EMAIL-->
      <v-card>
        <content-editor
          label="Text for send email"
          class="pos-relative"
          v-model="formData.metadata.textSentEmail.content"
          @input="$v.formData.metadata.textSentEmail.content.$touch"
          @blur="$v.formData.metadata.textSentEmail.content.$touch"
          :error="$v.formData.metadata.textSentEmail.content"
        />
      </v-card>
      <!--SEND EMAIL-->

      <!-- RESET PASSWORD -->
      <v-card>
        <content-editor
          label="Text for reset password"
          class="pos-relative"
          v-model="formData.metadata.textResetPassword.content"
          @input="$v.formData.metadata.textResetPassword.content.$touch"
          @blur="$v.formData.metadata.textResetPassword.content.$touch"
          :error="$v.formData.metadata.textResetPassword.content"
        />
      </v-card>
      <!-- RESET PASSWORD -->

      <!-- TEXT FOR EMAIL PLACEHOLDER -->
      <v-card>
        <content-editor
          label="Text for email placeholder"
          class="pos-relative"
          v-model="formData.metadata.textForEmailPlaceholder.content"
          @input="$v.formData.metadata.textForEmailPlaceholder.content.$touch"
          @blur="$v.formData.metadata.textForEmailPlaceholder.content.$touch"
          :error="$v.formData.metadata.textForEmailPlaceholder.content"
        />
      </v-card>
      <!-- TEXT FOR EMAIL PLACEHOLDER -->

      <!-- TEXT FOR PASSWORD PLACEHOLDER FIELD-->
      <v-card>
        <content-editor
          label="Text for password placeholder field"
          class="pos-relative"
          v-model="formData.metadata.textForPasswordPlaceholderField.content"
          @input="$v.formData.metadata.textForPasswordPlaceholderField.content.$touch"
          @blur="$v.formData.metadata.textForPasswordPlaceholderField.content.$touch"
          :error="$v.formData.metadata.textForPasswordPlaceholderField.content"
        />
      </v-card>
      <!-- TEXT FOR PASSWORD PLACEHOLDER FIELD-->

      <!-- TEXT FOR SUBMIT BUTTON -->
      <v-card>
        <content-editor
          label="Text for submit button"
          class="pos-relative"
          v-model="formData.metadata.textForSubmitButton.content"
          @input="$v.formData.metadata.textForSubmitButton.content.$touch"
          @blur="$v.formData.metadata.textForSubmitButton.content.$touch"
          :error="$v.formData.metadata.textForSubmitButton.content"
        />
      </v-card>
      <!--TEXT FOR SUBMIT BUTTON -->

      <v-btn
        class="btn_submit"
        color="success"
        @click.native="submitForm"
        :disabled="$v.$invalid || !isWriteAvailable"
      >
        Update Text
      </v-btn>
    </v-form>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { path, pathOr, clone } from 'ramda'
  import { required } from 'vuelidate/lib/validators'
  import mixins from '@/utils/mixins'

  export default {
    name: 'VoucherPage',
    mixins: [mixins.isWriteAvailable],
    data () {
      return {
        formData: '',
        displayFields: [],
        isLoader: false,
        // DON'T DELETE! need for isWriteAvailable mixin
        scopeForWrite: 'general_settings:write'
      }
    },
    validations: {
      formData: {
        metadata:{
          textCompletedStatus: {
            content: { required }
          },
          textPandingConfimationStatus: {
            content: { required }
          },
          textYourPasswordWasReset: {
            content: { required }
          },
          textSuccessSendEmail: {
            content: { required }
          },
          textLogIn: {
            content: { required }
          },
          textLoggedUserForContactUs: {
            content: { required }
          },
          textLoggedUserForCounterMessage: {
            content: { required }
          },
          textLoggedUserForGreeting: {
            content: { required }
          },
          textLoggedUserForStatusUser: {
            content: { required }
          },
          textSentEmail: {
            content: { required }
          },
          textResetPassword: {
            content: { required }
          },
          textForEmailPlaceholder: {
            content: { required }
          },
          textForPasswordPlaceholderField: {
            content: { required }
          },
          textForSubmitButton: {
            content: { required }
          }
        }
      }
    },
    computed: {
      ...mapGetters(
        [
          'getSettings',
          'staticContent'
        ]
      )
    },
    methods: {
      ...mapActions([
        'changeVoucherPage',
        'fetchGeneralSettings',
        'updateStaticContent',
        'createStaticContent',
        'fetchStaticContent'
      ]),
      async submitForm () {
        this.$v.$touch()
        if (this.$v.$invalid) return
        const payload = clone(this.formData)
        await this.updateStaticContent(payload)
        await this.fetchGeneralSettings()
      }
    },
    async created () {
      if (!this.getSettings) {
        await this.fetchGeneralSettings()
      }
      await this.fetchStaticContent()
      this.formData = this.staticContent.find((tab) => {
        if (tab.name === 'StatusChecker') {
          return tab
        }
      })
      this.isLoader = true
    }
  }
</script>

<style lang="scss" scoped>
  .input,
  .headline {
    max-width: 480px;
  }

  .form {
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }

  .headline {
    margin-bottom: 20px;
    text-align: center;
  }

  .card {
    padding: 10px;
    margin-bottom: 15px;
  }

  .z-index10 {
    z-index: 10;
    position: relative;
  }

  .pos-relative {
    position: relative;
  }

  .btn {
    &_submit {
      margin: 0 auto;
      margin-top: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/StaticPages/StatusChecker.vue